export default {
    NOT_ATTRIBUTED: 2,
    DISABLED: 3,
    FAMILY_VERIFIED: 9,
    PUBLICATION_REVOKED: 14,
    HAS_GIFTGIVER: 16,
    PUBLISHED: 13,
    GIFT_GIVING_REPORT_DESCRIBED: 17,
    GIFT_GIVING_REPORT_CHECKING: 18,
    GIFT_GIVING_REPORT_SEND: 22,
    CREATING_DESCRIPTION: 26,
    SEND_BACK_AREA_REACH: 30,
    SEND_BACK_NATIONAL_REACH: 31,
    FAMILY_VERIFIED_AREA_REACH: 27,
    FAMILY_VERIFIED_NATIONAL_REACH: 28,
    CREATING_FIRST_SHEET: 24,
    CREATING_SECOND_SHEET: 25,
    GIFT_GIVING_REPORT_AREA_REACH: 32,
    GIFT_GIVING_REPORT_NATIONAL_REACH: 33,
    GIFT_GIVING_REPORT_BACK_AREA_REACH: 35,
    GIFT_GIVING_REPORT_BACK_NATIONAL_REACH: 36,
    STATUS_FURTHER_STORY: 37,
    STATUS_FINISHED_SUMMARY: 38
};
